export * from 'ducks/global/tracker/actionTypes/events'

export const GLOBAL_EVENTS_INIT_IFRAME = '@GLOBAL/EVENTS/INIT_IFRAME'
export const GLOBAL_EVENTS_LISTENER_READY = '@GLOBAL/EVENTS/LISTENER_READY'
export const GLOBAL_EVENTS_SET_COOKIE = '@GLOBAL/EVENTS/SET_COOKIE'

export const GLOBAL_EVENTS_FETCH_CURRENT_USER =
  '@GLOBAL/EVENTS/FETCH_CURRENT_USER'
export const GLOBAL_EVENTS_FETCH_CURRENT_USER_PENDING =
  '@GLOBAL/EVENTS/FETCH_CURRENT_USER_PENDING'
export const GLOBAL_EVENTS_FETCH_CURRENT_USER_SUCCESS =
  '@GLOBAL/EVENTS/FETCH_CURRENT_USER_SUCCESS'
export const GLOBAL_EVENTS_FETCH_CURRENT_USER_FAILED =
  '@GLOBAL/EVENTS/FETCH_CURRENT_USER_FAILED'
export const GLOBAL_EVENTS_FETCH_CURRENT_USER_CANCELLED =
  '@GLOBAL/EVENTS/FETCH_CURRENT_USER_CANCELLED'

export const GLOBAL_EVENTS_SET_END_USER_ATTRIBUTE =
  '@GLOBAL/EVENTS/SET_END_USER_ATTRIBUTE'

export const GLOBAL_EVENTS_CHANGE_CONTAINER_CLASS =
  '@GLOBAL/EVENTS/CHANGE_CONTAINER_CLASS'
export const GLOBAL_EVENTS_CHANGE_CONTAINER_CLASS_DONE =
  '@GLOBAL/EVENTS/CHANGE_CONTAINER_CLASS_DONE'

export const GLOBAL_EVENTS_SET_DEBUG_MODE = '@GLOBAL/EVENTS/SET_DEBUG_MODE'

export const GLOBAL_EVENTS_DOMAIN_NOT_ALLOWED =
  '@GLOBAL/EVENTS/DOMAIN_NOT_ALLOWED'

export const GLOBAL_EVENTS_UPDATE_SETTINGS = '@GLOBAL/EVENTS/UPDATE_SETTINGS'
export const GLOBAL_EVENTS_UPDATE_TRANSLATIONS =
  '@GLOBAL/EVENTS/UPDATE_TRANSLATIONS'

export const GLOBAL_EVENTS_BOOTSTRAP_DONE = '@GLOBAL/EVENTS/BOOTSTRAP_DONE'

export const GLOBAL_EVENTS_OPEN = '@GLOBAL/EVENTS/GLOBAL_OPEN'
export const GLOBAL_EVENTS_CLOSE = '@GLOBAL/EVENTS/GLOBAL_CLOSE'
export const GLOBAL_EVENTS_TOGGLE = '@GLOBAL/EVENTS/GLOBAL_TOGGLE'
export const GLOBAL_EVENTS_RESIZE = '@GLOBAL/EVENTS/GLOBAL_RESIZE'

export const GLOBAL_EVENTS_BADGE_SIZED = '@GLOBAL/EVENTS/GLOBAL_BADGE_SIZED'

export const GLOBAL_EVENTS_ROUTE_CHANGE = '@GLOBAL/EVENTS/GLOBAL_ROUTE_CHANGE'
export const GLOBAL_EVENTS_GET_ROUTE = '@GLOBAL/EVENTS/GLOBAL_GET_ROUTE'

export const GLOBAL_EVENTS_OVERRIDE_TITLE = '@GLOBAL/EVENTS/OVERRIDE_TITLE'
export const GLOBAL_EVENTS_RESTORE_TITLE = '@GLOBAL/EVENTS/RESTORE_TITLE'

export const GLOBAL_EVENTS_GET_DATA = '@GLOBAL/EVENTS/GET_DATA'
export const GLOBAL_EVENTS_GET_DATA_SUCCESS = '@GLOBAL/EVENTS/GET_DATA_SUCCESS'
export const GLOBAL_EVENTS_GET_DATA_FAILED = '@GLOBAL/EVENTS/GET_DATA_FAILED'

export const GLOBAL_EVENTS_LAYOUT_CHANGE = '@GLOBAL/EVENTS/LAYOUT_CHANGE'

export const GLOBAL_EVENTS_DOWNLOAD_FILE = '@GLOBAL/EVENTS/DOWNLOAD_FILE'

export const GLOBAL_EVENTS_PLAY_AUDIO = '@GLOBAL/EVENTS/PLAY_AUDIO'
export const GLOBAL_EVENTS_SUBMIT_CONTACT_FORM =
  '@GLOBAL/EVENTS/SUBMIT_CONTACT_FORM'
